import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Tooltip from '@radix-ui/react-tooltip';

import { useTranslation } from 'react-i18next';

import { trackEvent } from '../../../lib/analytics';

// eslint-disable-next-line
import {
    BackgroundColorCircleBigIcon,
    BackgroundColorCircleBigIconNew,
} from '../../Icon';


// eslint-disable-next-line
import {
    enableBtnNewTableClick,
    enableBtnNewTableGrab,
    disableBtnNewTableGrab,
    enableBtnNewNoteClick,
    enableBtnNewNoteGrab,
    disableBtnNewNoteGrab,
    changeCursor,
    historyUndo,
    historyRedo,
    toggleBtnNewLine,
    toggleBtnNewArea,
    toggleBtnPen,
    focusAllElements,


    setNewPenColor,
    setNewPenWidth,
    clearNewPen,
} from '../../../redux/diagram/diagram.actions';

// eslint-disable-next-line
import {
    selectIsBtnNewTableClickEnabled,
    selectIsBtnNewTableGrabEnabled,
    selectIsBtnNewNoteClickEnabled,
    selectIsBtnNewNoteGrabEnabled,
    selectIsCursorHand,
    selectIsAvailableHistoryUndo,
    selectIsAvailableHistoryRedo,
    selectIsBtnNewLineEnabled,
    selectIsBtnNewAreaEnabled,
    selectIsBtnPenEnabled,
    selectIsBtnLeftPanelEnabled,
    selectFocusedInsideElement,
    selectIsEnabledElementDescriptionEditing,

    selectIsBtnExportImageEnabled,
    selectIsBtnSearchEnabled,
    selectIsBtnRedGreenViewEnabled,

    selectNewPenProps,
} from '../../../redux/diagram/diagram.selectors';

import {
    selectIsModalSupportEnabled,
    selectIsModalDiagramDetailsEnabled,
    selectIsModalDiagramQuickShareEnabled,
} from '../../../redux/main/main.selectors';


// eslint-disable-next-line
import {
    UndoIconNew,
    RedoIconNew,

    // NosqlDocumentIcon,
    // NosqlCollectionIcon,
    // CodeBlockIcon,
    CommentIcon,

    // LineIcon,
    LineIconNew,
    // TableGroupIcon,
    TableGroupNewIcon,
    PenIconNew,
    PointerIconNew,
    // TableIconNew,
    TableIconNewControls,
    NoteIcon,
    // TableDarkIcon,
    // TableLightIcon,
    // GridIcon,
    // AiIcon,
    // CodeIcon,
    // PointerIcon,
    // PencilIcon
    MacCommandIcon,
} from '../../Icon';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';
import { useDeviceType } from '../../../hooks/useDeviceType.ts';

import './ControlsLeft.scss';

export const ControlsLeft = () => {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();

    const { map: shortKeysMap, isMac } = useShortKeysNavigation();

    const { isDesktop, isDesktop1350 } = useDeviceType();

    const isCursorHand = useSelector(selectIsCursorHand);
    const isAvailableHistoryUndo = useSelector(selectIsAvailableHistoryUndo);
    const isAvailableHistoryRedo = useSelector(selectIsAvailableHistoryRedo);
    const isBtnLeftPanelEnabled = useSelector(selectIsBtnLeftPanelEnabled);

    const focusedInsideElementRedux = useSelector(selectFocusedInsideElement);

    const isModalSupportEnabled = useSelector(selectIsModalSupportEnabled);
    const isModalDiagramDetailsEnabled = useSelector(selectIsModalDiagramDetailsEnabled);
    const isModalDiagramQuickShareEnabled = useSelector(selectIsModalDiagramQuickShareEnabled);


    const isBtnExportImageEnabled = useSelector(selectIsBtnExportImageEnabled);
    const isBtnSearchEnabled = useSelector(selectIsBtnSearchEnabled);
    const isBtnRedGreenViewEnabled = useSelector(selectIsBtnRedGreenViewEnabled);


    const isEnabledElementDescriptionEditing = useSelector(selectIsEnabledElementDescriptionEditing);

    const isBtnNewTableClickEnabled = useSelector(
        selectIsBtnNewTableClickEnabled
    );
    const isBtnNewTableGrabEnabled = useSelector(
        selectIsBtnNewTableGrabEnabled
    );
    const tableRef = useRef(null);
    const [isBtnTablePressed, setIsBtnTablePressed] = useState(false);

    const isBtnNewNoteClickEnabled = useSelector(
        selectIsBtnNewNoteClickEnabled
    );
    const isBtnNewNoteGrabEnabled = useSelector(selectIsBtnNewNoteGrabEnabled);
    const noteRef = useRef(null);
    const [isBtnNotePressed, setIsBtnNotePressed] = useState(false);

    const isBtnNewLineEnabled = useSelector(selectIsBtnNewLineEnabled);
    const isBtnNewAreaEnabled = useSelector(selectIsBtnNewAreaEnabled);
    const isBtnPenEnabled = useSelector(selectIsBtnPenEnabled);

    const startXYRef = useRef({ x: 0, y: 0 });

    const newPenProps = useSelector(selectNewPenProps);

    const penBtnRef = useRef(null);
    const penMenuRef = useRef(null);

    useEffect(() => {
        const handleTableMouseDown = (event) => {
            // check if press any button exept 'left mouse button' then return nothing
            if (event.button !== 0) {
                return;
            }

            setIsBtnTablePressed(true);
            startXYRef.current = { x: event.clientX, y: event.clientY };
        };
        const handleNoteMouseDown = (event) => {
            // check if press any button exept 'left mouse button' then return nothing
            if (event.button !== 0) {
                return;
            }
            setIsBtnNotePressed(true);
            startXYRef.current = { x: event.clientX, y: event.clientY };
        };

        const handleDocumentMouseMove = (event) => {
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            if (
                isBtnTablePressed &&
                (Math.abs(mouseX - startXYRef.current.x) >= 20 ||
                    Math.abs(mouseY - startXYRef.current.y) >= 20)
            ) {
                trackEvent('playground_control_new_table_grab', {
                    page: 'playground',
                    type: 'controls',
                    subtype: 'left',
                });
                dispatch(enableBtnNewTableGrab());
                setIsBtnTablePressed(false);
            }

            if (
                isBtnNotePressed &&
                (Math.abs(mouseX - startXYRef.current.x) >= 20 ||
                    Math.abs(mouseY - startXYRef.current.y) >= 20)
            ) {
                trackEvent('playground_control_new_note_grab', {
                    page: 'playground',
                    type: 'controls',
                    subtype: 'left',
                });
                dispatch(enableBtnNewNoteGrab());
                setIsBtnNotePressed(false);
            }
        };
        const handleTableClick = () => {
            // if it's not grab, then it's click
            if (!isBtnNewTableGrabEnabled) {
                trackEvent('playground_control_new_table', {
                    page: 'playground',
                    type: 'controls',
                    subtype: 'left',
                });
                dispatch(enableBtnNewTableClick());
                // cursor = 'new_table';
                setIsBtnTablePressed(false);
            }
        };
        const handleNoteClick = () => {
            // if it's not grab, then it's click
            if (!isBtnNewNoteGrabEnabled) {
                trackEvent('playground_control_new_note', {
                    page: 'playground',
                    type: 'controls',
                    subtype: 'left',
                });
                dispatch(enableBtnNewNoteClick());
                // cursor = 'new_table';
                setIsBtnNotePressed(false);
            }
        };

        const handleDocumentClick = (event) => {
            event.preventDefault();
            // end of possible grab, check first for no additional actions
            if (isBtnNewTableGrabEnabled) {
                dispatch(disableBtnNewTableGrab());
            }
            // end of possible grab, check first for no additional actions
            if (isBtnNewNoteGrabEnabled) {
                dispatch(disableBtnNewNoteGrab());
            }

            // end of possible press, check first for no additional actions
            if (isBtnTablePressed) {
                setIsBtnTablePressed(false);
            }
            // end of possible press, check first for no additional actions
            if (isBtnNotePressed) {
                setIsBtnNotePressed(false);
            }
        };

        tableRef.current.addEventListener('mousedown', handleTableMouseDown);
        // todo: note disabled
        // noteRef.current.addEventListener('mousedown', handleNoteMouseDown);

        document.addEventListener('mousemove', handleDocumentMouseMove);

        tableRef.current.addEventListener('click', handleTableClick);

        // todo: note disabled
        // noteRef.current.addEventListener('click', handleNoteClick);

        document.addEventListener('click', handleDocumentClick);

        return () => {
            if (tableRef.current) {
                tableRef.current.removeEventListener(
                    'mousedown',
                    handleTableMouseDown
                );

                tableRef.current.removeEventListener('click', handleTableClick);
            }

            if (tableRef.current) {
                noteRef.current.removeEventListener(
                    'mousedown',
                    handleNoteMouseDown
                );

                noteRef.current.removeEventListener('click', handleNoteClick);
            }

            document.removeEventListener('mousemove', handleDocumentMouseMove);

            document.removeEventListener('click', handleDocumentClick);
        };
    }, [
        dispatch,
        isBtnNewTableGrabEnabled,
        isBtnNewNoteGrabEnabled,
        isBtnTablePressed,
    ]);

    useEffect(() => {
        const handleKeyPress = (event) => {
            const isCtrl = isMac ? event.metaKey : event.ctrlKey;

            const isOpenTextEditing = focusedInsideElementRedux || isEnabledElementDescriptionEditing;

            // Ignore events from disabled or read-only elements
            if (
                event.target.disabled ||
                event.target.readOnly ||
                isOpenTextEditing ||
                isModalDiagramDetailsEnabled ||
                isModalSupportEnabled ||
                isModalDiagramQuickShareEnabled ||
                isBtnExportImageEnabled ||
                isBtnSearchEnabled ||
                isBtnRedGreenViewEnabled
            ) {
                return;

            } else {
                // [ V ]
                if (
                    event.code === 'KeyV' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_mouse_select', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(changeCursor());
                }
                // [ T ]
                else if (
                    event.code === 'KeyT' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_new_table', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(enableBtnNewTableClick());
                }
                // [ L ]
                else if (
                    event.code === 'KeyL' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_new_line', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(toggleBtnNewLine());
                }
                // [ A ]
                else if (
                    event.code === 'KeyA' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_new_area', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(toggleBtnNewArea(true));
                }
                // [ N ]
                // else if (
                //     event.code === 'KeyN' &&
                //     !event.ctrlKey &&
                //     !event.metaKey &&
                //     !event.altKey &&
                //     !event.shiftKey
                // ) {
                //     event.preventDefault();
                //     dispatch(enableBtnNewNoteClick());
                // }
                // [ P ]
                else if (
                    event.code === 'KeyP' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_new_pen', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(toggleBtnPen());
                }
                // [CTRL + Z]
                else if (
                    event.code === 'KeyZ' &&
                    isCtrl &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();

                    if (isAvailableHistoryUndo) {
                        trackEvent('playground_shortcut_history_undo', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        dispatch(historyUndo());
                    }
                }
                // [CTRL + SHIFT + Z]
                else if (
                    event.code === 'KeyZ' &&
                    isCtrl &&
                    event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();

                    if (isAvailableHistoryRedo) {
                        trackEvent('playground_shortcut_history_redo', {
                            page: 'playground',
                            type: 'shortcuts',
                        });
                        dispatch(historyRedo());
                    }
                }
                // [ CTRL + A ]
                else if (
                    event.code === 'KeyA' && isCtrl &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    trackEvent('playground_shortcut_focus_all', {
                        page: 'playground',
                        type: 'shortcuts',
                    });
                    dispatch(focusAllElements(true));
                }
                // [ESC]
                else if (event.code === 'Escape') {
                    event.preventDefault();

                    if (isBtnNewTableClickEnabled) {
                        dispatch(enableBtnNewTableClick());
                    }
                    if (isBtnNewNoteClickEnabled) {
                        dispatch(enableBtnNewNoteClick());
                    }
                    if (isBtnNewLineEnabled) {
                        dispatch(toggleBtnNewLine());
                    }
                    if (isBtnNewAreaEnabled) {
                        dispatch(toggleBtnNewArea());
                    }
                    if (isBtnPenEnabled) {
                        dispatch(toggleBtnPen());
                    }
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [
        dispatch,
        isModalSupportEnabled,
        isModalDiagramQuickShareEnabled,
        isModalDiagramDetailsEnabled,
        focusedInsideElementRedux,
        isAvailableHistoryUndo,
        isAvailableHistoryRedo,
        isBtnNewTableClickEnabled,
        isBtnNewNoteClickEnabled,
        isBtnNewLineEnabled,
        isBtnNewAreaEnabled,
        isBtnPenEnabled,
        isEnabledElementDescriptionEditing,

        isBtnExportImageEnabled,
        isBtnSearchEnabled,
        isBtnRedGreenViewEnabled,
    ]);




    // pen menu
    const getPenMenu = (isBtnPenEnabled) => {
        if (!isBtnPenEnabled || !penBtnRef.current) {
            return;
        }

        const rect = penBtnRef.current.getBoundingClientRect();
        let top = rect.bottom + window.scrollY;
        let left = rect.left + window.scrollX;

        top = top - 351 + 7;
        left = left + 42;

        if (isDesktop1350) {
            top = top + 126 + 7;
            left = left - 10;
        }

        return (
            <div
                className={`pen-menu-group`}
                ref={penMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group colors">
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'yellow' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent('playground_control_new_pen_yellow', {
                                    page: 'playground',
                                    type: 'controls',
                                    subtype: 'left',
                                });
                                dispatch(setNewPenColor('yellow'));
                            }}
                        >
                            {isDesktop1350
                                ? <BackgroundColorCircleBigIconNew color={'#ffc65e'} isSelected={newPenProps.color === 'yellow'} />
                                : <BackgroundColorCircleBigIcon color={'#ffc65e'} isSelected={newPenProps.color === 'yellow'} />
                            }
                        </button>
                    </div>
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'red' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent('playground_control_new_pen_red', {
                                    page: 'playground',
                                    type: 'controls',
                                    subtype: 'left',
                                });
                                dispatch(setNewPenColor('red'));
                            }}
                        >
                            {isDesktop1350
                                ? <BackgroundColorCircleBigIconNew color={'red'} isSelected={newPenProps.color === 'red'} />
                                : <BackgroundColorCircleBigIcon color={'red'} isSelected={newPenProps.color === 'red'} />
                            }
                        </button>
                    </div>
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'lightgreen' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                trackEvent('playground_control_new_pen_green', {
                                    page: 'playground',
                                    type: 'controls',
                                    subtype: 'left',
                                });
                                dispatch(setNewPenColor('lightgreen'));
                            }}
                        >
                            {isDesktop1350
                                ? <BackgroundColorCircleBigIconNew color={'lightgreen'} isSelected={newPenProps.color === 'lightgreen'} />
                                : <BackgroundColorCircleBigIcon color={'lightgreen'} isSelected={newPenProps.color === 'lightgreen'} />
                            }
                        </button>
                    </div>
                </div>

                {/* <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button small disabled ${viewMode === 'keys' ? 'selected' : ''
                                }`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setNewPenWidth(2));
                            }}
                        >
                            -------o--------------
                        </button>
                    </div>
                </div> */}

                <div className="controls-group">
                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={1000} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button small hovered clear-button`}
                                    type="button"
                                    // title=""
                                    // aria-label="Color"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_control_new_pen_clear', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                        dispatch(clearNewPen());
                                    }}
                                >
                                    {t('b.clear')}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls tooltip-back-link wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('b.clear')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };



    return (
        // <div className='controls_left' style={{ left: `${isBtnLeftPanelEnabled ? 330 : 10}px` }}>
        // <div className='controls_left' style={{ left: `${isBtnLeftPanelEnabled ? 366 + 18 : 10}px` }}>
        <div
            className={`controls_left ${isBtnExportImageEnabled ? 'hide' : ''}`}
            style={{
                transform: 'translateX(0), translateY(-50px)',
                left: `${(isBtnLeftPanelEnabled && !isBtnExportImageEnabled) ? 320 + 18 : 9}px`,
            }}
        >
            <div className="controls-row">

                {getPenMenu(isBtnPenEnabled)}

                <div className="controls-group">
                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button control-button-p-l-2 ${!isCursorHand && 'selected'
                                        }`}
                                    type="button"
                                    // title="Muliselect | [V]"
                                    // aria-label="Pointer"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_control_mouse_select', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                        dispatch(changeCursor());
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                    }}
                                >
                                    <PointerIconNew />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.mouse_select')}</span>
                                <span className="tooltip-shortcut">V</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider"></div>

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={tableRef}
                                    type="button"
                                    className={`control-button ${(isBtnTablePressed ||
                                        isBtnNewTableClickEnabled ||
                                        isBtnNewTableGrabEnabled) &&
                                        'selected'
                                        }`}
                                    // title="Table | [T]"
                                    // aria-label="Table"
                                    aria-pressed="false"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                    }}
                                // onClick={(event) => { handleClick(event); }}
                                >
                                    <TableIconNewControls />
                                    {/* {themeMode ? <TableLightIcon className={'controls-left'} /> : <TableDarkIcon className={'controls-left'} />} */}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.table')}</span>
                                <span className="tooltip-shortcut">T</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root ignoreNonKeyboardFocusdelayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control line-control">
                                <button
                                    className={`control-button line-btn ${isBtnNewLineEnabled && 'selected'
                                        }`}
                                    type="button"
                                    // title="Line | [L]"
                                    // aria-label="Relation"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_control_new_line', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                        dispatch(toggleBtnNewLine());
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    {/* <LineIcon /> */}
                                    <LineIconNew />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.line')}</span>
                                <span className="tooltip-shortcut">L</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button ${isBtnNewAreaEnabled && 'selected'
                                        }`}
                                    type="button"
                                    // title="Area [A]"
                                    // aria-label="2-Table Group"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_control_new_area', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                        dispatch(toggleBtnNewArea());
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                    }}
                                >
                                    <TableGroupNewIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.area')}</span>
                                {/* <span className="tooltip-shortcut">G</span> */}
                                <span className="tooltip-shortcut">A</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root ignoreNonKeyboardFocusdelayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled
                                    ref={noteRef}
                                    type="button"
                                    className={`control-button disabled ${(isBtnNotePressed || isBtnNewNoteClickEnabled || isBtnNewNoteGrabEnabled) && 'selected'}`}
                                    // title="Note | [N]"
                                    // aria-label="Note"
                                    aria-pressed="false"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                    }}
                                >
                                    <NoteIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.note')}</span>
                                <span className="tooltip-shortcut">N</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Add Table"
						aria-label="Add Table"
						aria-pressed="false"
					>
						Table View ??
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Add Table"
						aria-label="Add Table"
						aria-pressed="false"
					>
						Procedures ??
					</button>
				</div> */}
                    {/*
					<div className="control-divider"></div>

					<div className="control">
						<button
							className={`control-button not-now`}
							type="button"
							title="3-NoSQL Collection"
							aria-label="3-NoSQL Collection"
							aria-pressed="false"
						>
							<NosqlCollectionIcon />
						</button>
					</div>
					<div className="control">
						<button
							className={`control-button not-now`}
							type="button"
							title="3-NoSQL Document"
							aria-label="3-NoSQL Document"
							aria-pressed="false"
						>
							<NosqlDocumentIcon />
						</button>
					</div>
					<div className="control-divider"></div>

					<div className="control">
						<button
							className={`control-button not-now`}
							type="button"
							title="2-Code Block // add new code js, ts, whatever"
							aria-label="2-Code Block"
							aria-pressed="false"
						>
							<CodeBlockIcon />
						</button>
					</div>

					<div className="control-divider"></div>

					<div className="control">
						<button
							className={`control-button sql not-now`}
							type="button"
							title="2-Import By SQL Code"
							aria-label="2-SQL"
							aria-pressed="false"
						>
							SQL
						</button>
					</div> */}

                    {/* <div className="control-divider"></div> */}

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled
                                    className="control-button not-now disabled"
                                    type="button"
                                    // title="2-Comment"
                                    // aria-label="2-Comment"
                                    aria-pressed="false"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                    }}
                                    onClick={() => {
                                        trackEvent('playground_control_new_comment', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                    }}
                                >
                                    <CommentIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.comment')}</span>
                                <span className="tooltip-shortcut">C</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <div className="control-divider"></div> */}

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={penBtnRef}
                                    className={`control-button control-button-p-l-2 ${isBtnPenEnabled && 'selected'}`}
                                    type="button"
                                    // title="Pen | [P]"
                                    // aria-label="Pen"
                                    aria-pressed="false"
                                    onClick={() => {
                                        trackEvent('playground_control_new_pen', {
                                            page: 'playground',
                                            type: 'controls',
                                            subtype: 'left',
                                        });
                                        dispatch(toggleBtnPen());
                                    }}
                                >
                                    <PenIconNew />
                                    {/* {themeMode ? <TableLightIcon className={'controls-left'} /> : <TableDarkIcon className={'controls-left'} />} */}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.pen')}</span>
                                <span className="tooltip-shortcut">P</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <div className="control-divider"></div>

				<div className="control">
					<button
						className={`control-button ${isOpenAiModal && 'selected'}`}
						type="button"
						title="AI Assistant"
						aria-label="AI Assistant"
						aria-pressed="false"
						onClick={(event) => { dispatch(changeAiModal({ mode: event.a })); }}
					>
						<AiIcon />
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Template"
						aria-label="Template"
						aria-pressed="false"
					>
						3-Templates
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button ${isOpenCodeModal && 'selected'}`}
						type="button"
						title="Code"
						aria-label="Code"
						aria-pressed="false"
						onClick={(event) => { dispatch(changeCodeModal({ mode: event.a })); }}
					>
						<CodeIcon />
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button ${isGridEnabled && 'selected'}`}
						type="button"
						title="Grid"
						aria-label="Grid"
						aria-pressed="false"
						onClick={() => dispatch(enableGrid({}))}
					>
						<GridIcon />
					</button>
				</div> */}

                    {/* <div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Add Figure"
						aria-label="Add Figure"
						aria-pressed="false"
					>
						Figures??
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Clone Template"
						aria-label="Clone Template"
						aria-pressed="false"
					>
						AWS?? Shapes
					</button>
				</div>

				<div className="control">
					<button
						className={`control-button`}
						type="button"
						title="Clone Template"
						aria-label="Clone Template"
						aria-pressed="false"
					>
						Image?? (notnow)
					</button>
				</div> */}

                    {/* <div className="control">
					<button
						className={`control-button ${sketchView === 'before' && 'selected'}`}
						type="button"
						title="Full Screen"
						aria-label="Full Screen"
						aria-pressed="false"
						onClick={() => dispatch(changeSketchView({ sketchView: 'before' }))}
					>
						<PencilIcon />
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button ${sketchView === 'changes' && 'selected'}`}
						type="button"
						title="Full Screen"
						aria-label="Full Screen"
						aria-pressed="false"
						onClick={() => dispatch(changeSketchView({ sketchView: 'changes' }))}
					>
						<PencilIcon />
					</button>
				</div>
				<div className="control">
					<button
						className={`control-button ${sketchView === 'after' && 'selected'}`}
						type="button"
						title="Full Screen"
						aria-label="Full Screen"
						aria-pressed="false"
						onClick={() => dispatch(changeSketchView({ sketchView: 'after' }))}
					>
						<PencilIcon />
					</button>
				</div> */}
                </div>
                <div className="controls-group">
                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled={!isAvailableHistoryUndo}
                                    className={`control-button button-history ${!isAvailableHistoryUndo && 'disabled'
                                        }`}
                                    type="button"
                                    // title="Undo | [CTRL + Z]"
                                    // aria-label="Undo"
                                    aria-pressed="false"
                                    onClick={() => dispatch(historyUndo({}))}
                                >
                                    <UndoIconNew />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.undo')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + Z
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled={!isAvailableHistoryRedo}
                                    className={`control-button button-history ${!isAvailableHistoryRedo && 'disabled'
                                        }`}
                                    type="button"
                                    // title="Redo | [CTRL + SHIFT + Z]"
                                    // aria-label="Redo"
                                    aria-pressed="false"
                                    onClick={() => dispatch(historyRedo({}))}
                                >
                                    <RedoIconNew />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="right"
                                align="center"
                                sideOffset={12}
                            >
                                <span>{t('t.ctrl_left.redo')}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + Shift + Z
                                </span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        </div>
    );
};

export default ControlsLeft;
